import { useSelector } from "react-redux";
import React from "react";
import saly from "../images/empty.jpg";

export const EmptyTable = (props) => {
    const lang = useSelector(state => state.app.currentLang)
    let header;
    if (props.isActive === 1) {
        header = lang.message8;
    } else {
        header = lang.message1;
    }
    return (
        <div className="emptyTable">
            <div className="emptyTable__heading">
                <div className="emptyTable__heading_border">
                    <div className={"emptyTable__tittle " + (props.isActive && "isActive")}><span>{header}</span></div>
                </div>
            </div>
            <div className="emptyTable__img" style={{ backgroundImage: 'url(' + saly + ')' }}></div>
        </div>)
}